<script>

import ChatService from "@/services/ChatService";
import CreateTagDialog from "@/views/master/systemconfig/chat/tag/dialog/CreateTagDialog.vue";
import UpdateTagDialog from "@/views/master/systemconfig/chat/tag/dialog/UpdateTagDialog.vue";

const headerCellStyle = () => {
  return {
    backgroundColor: "#78a5e7",
    color: "#fff",
  }
}

export default {
  components: {UpdateTagDialog, CreateTagDialog},
  computed: {
    sortedDataTableEmotion() {
      return [...this.dataTableTag].sort((a, b) => {
        if (a.active !== b.active) {
          return a.active === true ? -1 : 1;
        }
      });
    }
  },

  data() {
    return {
      isLoading: false,
      dataTableTag: [],
      isOpenDialog: {
        create: false,
        update: false,
      },
      filter: {
        search: "",
        page: 1,
        limit: 10,
        total: 0,
      },
      listPageSizes: [10, 30, 40, 50, 100, 200, 500]
    }
  },

  watch: {},

  created() {
    this.fetchDataTags();
  },

  methods: {
    headerCellStyle,
    handleOpenCreateDialog() {
      this.isOpenDialog.create = true;
    },

    handleUpdateTag(data) {
      this.$refs.updateTagDialog.initialDataUpdate(data);
      this.isOpenDialog.update = true;
    },

    handleSelectionChange(value) {
      this.selectionMultiple = value;
    },

    /**
     * Xử lý API lấy tất cả thẻ
     * */
    fetchDataTags() {
      ChatService.tagService.getAll(this.filter.page, this.filter.limit, this.filter.search)
          .then((res) => {
            let response = res.data
            this.dataTableTag = response.data.content.map((item) => ({
              ...item,
              tempActive: item.active,
            }));

            this.filter.total = response.total;
          })
          .catch((err) => {
            console.log(err);
          });
    },

    /**
     * Gọi API cập nhật sử dụng thẻ
     * */
    fetchUpdateActive(value, data) {
      return ChatService.tagService
          .updateActive(data)
          .then((res) => {
            const dataNew = res.data.data;
            if (dataNew !== null) {
              this.handleSuccessUpdate(dataNew);
              this.$message({message: res.data.message, type: "success"});
              return true; // Trả về true nếu API thành công
            }
            return false;
          })
          .catch((err) => {
            console.log(err);
            this.$message.error("Đã có lỗi xảy ra, vui lòng thử lại!");
            return false; // Trả về false nếu API thất bại
          });
    },

    fetchDelete(data) {
      ChatService.tagService.delete([data.id])
          .then((res) => {
            this.handleSuccessDelete(data.id);
            this.$message({message: res.data.message, type: "success"});
          })
          .catch((err) => {
            console.log(err);
            this.$message({message: err.message, type: "error"});
          })
    },

    handleFilterData() {
      this.fetchDataTags();
    },

    handleSizeChange(value) {
      this.filter.limit = value;
      this.fetchDataTags();
    },

    handleCurrentPageChange(value) {
      this.filter.page = value;
      this.fetchDataTags();
    },

    handleSuccessCreated(data) {
      this.dataTableTag.push({...data, tempActive: data.active});
      this.isOpenDialog.create = false;
    },

    handleSuccessUpdate(data) {
      const index = this.dataTableTag.findIndex((e) => e.id === data.id);
      if (index !== -1) {
        this.$set(this.dataTableTag, index, {...data, tempActive: data.active});
      }
      this.isOpenDialog.update = false;
    },

    handleSuccessDelete(ids) {
      const idList = Array.isArray(ids) ? ids : [ids];
      this.dataTableTag = this.dataTableTag.filter(
          item => !idList.includes(item.id)
      );
    },

    async onChangeActive(value, row) {
      // Gọi API
      const success = await this.fetchUpdateActive(value, row);
      if (success) {
        // Cập nhật active nếu API thành công
        row.active = value;
        row.tempActive = value;
      } else {
        // Hoàn nguyên tempActive nếu API thất bại
        this.$set(row, "tempActive", row.active);
      }
    },

    deleteTag(data) {
      this.$confirm(`Bạn có chắc muốn xoá thẻ "<span class="el-icon-caret-right" style="color: ${data.color}"></span> <span style="font-weight: bold; font-family: Arial, sans-serif">${data.title}</span>" không? <br/> Sẽ không thể hoàn tác!`, "Thông báo!", {
        dangerouslyUseHTMLString: true,
        distinguishCancelAndClose: true,
        confirmButtonText: "Có",
        closeOnClickModal: false,
        cancelButtonText: "Không",
        type: "warning",
      })
          .then(async () => {
            this.fetchDelete(data);
          })
    }
  }
}
</script>

<template>
  <div>
    <!-- Bộ lọc -->
    <section>
      <el-row type="flex" justify="space-between">
        <!--      <el-col :span="20">-->
        <!--        <el-row type="flex" :gutter="4">-->

        <!--          <el-col :span="3">-->
        <!--            <el-select-->
        <!--                v-model="dataFilter.statusActive"-->
        <!--                placeholder="Trạng thái phiếu" style="width: 100%"-->
        <!--                @change="handleFilterData"-->
        <!--                :clearable="true"-->
        <!--            >-->
        <!--              <el-option-->
        <!--                  v-for="(item, index) in optionsStatusForm"-->
        <!--                  :key="index"-->
        <!--                  :label="item.label"-->
        <!--                  :value="item.value"-->
        <!--              >-->
        <!--              </el-option>-->
        <!--            </el-select>-->
        <!--          </el-col>-->


        <!--          <el-col :span="6">-->
        <!--            <el-date-picker-->
        <!--                style="width: 100%"-->
        <!--                v-model="dataFilter.dateRange"-->
        <!--                type="daterange"-->
        <!--                range-separator="-"-->
        <!--                start-placeholder="Thời gian tạo"-->
        <!--                end-placeholder="Thời gian tạo"-->
        <!--                format="dd/MM/yyyy"-->
        <!--                value-format="yyyy-MM-dd"-->
        <!--                @change="handleFilterData"-->
        <!--            >-->
        <!--            </el-date-picker>-->
        <!--          </el-col>-->

        <!--          <el-col :span="3">-->
        <!--            <el-select-->
        <!--                v-model="dataFilter.type"-->
        <!--                placeholder="Loại phiếu" style="width: 100%"-->
        <!--                @change="handleFilterData"-->
        <!--                :clearable="true"-->
        <!--            >-->
        <!--              <el-option-->
        <!--                  v-for="(item, index) in optionsTypeApply"-->
        <!--                  :key="index"-->
        <!--                  :label="item.label"-->
        <!--                  :value="item.value"-->
        <!--              >-->
        <!--              </el-option>-->
        <!--            </el-select>-->
        <!--          </el-col>-->

<!--        <el-col :span="6">-->
        <!--          <el-input-->
        <!--              :clearable="true"-->
        <!--              style="width: 100%"-->
        <!--              placeholder="Nhập tên thẻ hoặc mã thẻ"-->
        <!--              v-model="filter.search"-->
        <!--              @keyup.enter.native="handleFilterData"-->
        <!--              @clear="handleFilterData"-->
        <!--          >-->
        <!--            <template #append>-->
        <!--              <el-button-->
        <!--                  icon="el-icon-search"-->
        <!--                  @click="handleFilterData"-->
        <!--              ></el-button>-->
        <!--            </template>-->
        <!--          </el-input>-->
        <!--        </el-col>-->

        <!--          <el-col :span="1">-->
        <!--            <el-button-->
        <!--                style="-->
        <!--                    width: 100%;-->
        <!--                    padding-left: 10px;-->
        <!--                    padding-right: 10px;"-->
        <!--                plain-->
        <!--                :type="isAdvancedFilter ? 'danger' : 'primary'"-->
        <!--                @click="handleOpenAdvancedFilter"-->
        <!--                :icon="'el-icon-circle-plus'"/>-->
        <!--          </el-col>-->

        <!--          <el-col :span="1" v-if="isAdvancedFilter">-->
        <!--            <el-button-->
        <!--                style="-->
        <!--                    width: 100%;-->
        <!--                    padding-left: 10px;-->
        <!--                    padding-right: 10px;"-->
        <!--                type="danger"-->
        <!--                plain-->
        <!--                @click="handleResetAdvancedFilter"-->
        <!--                :icon="'el-icon-refresh-left'"/>-->
        <!--          </el-col>-->

        <!--        </el-row>-->
        <!--      </el-col>-->

        <el-col :span="2">
          <el-button style="width: 100%" type="success" @click="handleOpenCreateDialog">
            <i class="el-icon-plus"/>
            Thêm mới
          </el-button>
        </el-col>
      </el-row>
    </section>

    <!-- Phần bảng quản lý -->
    <section>
      <div style="margin: 20px 0">
        <el-table
            ref="tableSurveyForm"
            element-loading-spinner="el-icon-loading"
            :data="sortedDataTableEmotion"
            border
            :max-height="$tableMaxHeight"
            :header-cell-style="headerCellStyle"
            :element-loading-text="$tableLoading"
            @selection-change="handleSelectionChange"
            element-loading-background="rgba(255,255,255, 0)"
            v-loading="isLoading"
        >

          <el-table-column
              type="index"
              label="STT"
              width="50"
              align="center"
          />

          <el-table-column
              label="Ngày tạo"
              width="160"
              align="center"
          >
            <template v-slot:default="scope">
              <span>{{ scope.row.date | formatDateTime }}</span>
            </template>
          </el-table-column>

          <el-table-column
              label="Mã thẻ"
              width="180"
              align="center"
          >
            <template v-slot:default="scope">
              <span style="text-transform: uppercase">{{ scope.row.id }}</span>
            </template>
          </el-table-column>

          <el-table-column
              label="Tiêu đề"
          >
            <template v-slot:default="scope">
              <span>{{ scope.row.title }}</span>
            </template>
          </el-table-column>

          <el-table-column
              label="Màu / Mã màu"
              width="200"
              align="center"
          >
            <template v-slot:default="scope">
              <div style="display: flex; justify-content: center; align-items: center; gap: 10px;">
                <span
                    :style="{
                      display: 'block',
                      width: '20px',
                      height: '20px',
                      backgroundColor: scope.row.color,
                      borderRadius: '4px',}">

                </span>
                <span> / </span>
                <span>{{ scope.row.color }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
              label="Sử dụng"
              width="150"
              align="center"
          >
            <template v-slot:default="scope">
              <span>
                <el-checkbox v-model="scope.row.tempActive" @change="(data) => onChangeActive(data, scope.row)"/>
              </span>
            </template>
          </el-table-column>

          <el-table-column
              label="Tác vụ"
              width="240"
              align="center"
          >
            <template v-slot:default="scope">
              <div>
                <el-button @click="handleUpdateTag(scope.row)" size="small" type="success">
                  Sửa
                </el-button>

                <el-button @click="deleteTag(scope.row)" size="small" type="danger">
                  Xoá
                </el-button>
              </div>
            </template>
          </el-table-column>

          <template #empty>
            <div style="text-align: center; font-size: 16px; color: #43a0ff;">
              <i class="el-icon-warning"></i>
              <span> Không có dữ liệu! </span>
            </div>
          </template>
        </el-table>
      </div>
    </section>

    <section>
      <el-row type="flex" justify="center">
        <el-col :span="4">
          <div class="">
            <el-pagination
                background
                layout="prev, pager, next, sizes"
                @size-change="handleSizeChange"
                @current-change="handleCurrentPageChange"
                :current-page.sync="filter.page"
                :page-sizes="listPageSizes"
                :total="filter.total">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </section>

    <!-- Dialog -->
    <section>
      <CreateTagDialog
          :is-open="isOpenDialog.create"
          @closeDialog="isOpenDialog.create = false"
          @success="handleSuccessCreated"
      />

      <UpdateTagDialog
          :is-open="isOpenDialog.update"
          @closeDialog="isOpenDialog.update = false"
          @success="handleSuccessUpdate"
          ref="updateTagDialog"
      />
    </section>
  </div>
</template>

<style scoped lang="scss">

</style>